import React, { useEffect } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WorkVisaDetail from './components/WorkVisaDetail';


import AboutPage from './pages/About';
import Home from './pages/Home';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import ServicesPage from './pages/Services';
import ContactPage from './pages/Contact';
import CountriesPage from './pages/Contries';
import CountryDetail from './pages/ContryDetail';
import PopularVisas from './pages/PopularVisas';

import AOS from "aos";
import "aos/dist/aos.css";


const ScrollToTop = () => { 
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, [pathname]);

  return null;
};

function App() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      offset: 60,         // less movement
      easing: "ease-out",
    });
  }, []);

  return (
    <BrowserRouter>
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-blue-100">
        <Navbar />
        <ScrollToTop/>
        <Routes>
          <Route path="/" element={<Home/>}/>
          <Route path="/about" element={<AboutPage/>}/>
          <Route path="/services" element={<ServicesPage/>}/>
          <Route path="/contact" element={<ContactPage/>}/>
          <Route path="/countries" element={<CountriesPage/>}/>
          <Route path="/country/:id" element={<CountryDetail/>}/>
          <Route path="/popular-visas" element={<PopularVisas/>}/>
          <Route path="/popular-visas/:slug" element={<WorkVisaDetail/>}/>
       
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
